import { computed, defineComponent, onMounted, reactive, ref, watch } from 'vue';
import Footer from '@/components/Footer.vue';
import Banner from '@/components/Banner.vue';
import router from '@/router';
import moment from 'moment';
import { getAdPlanList, getUserSoftware } from '@/http/api';
export default defineComponent({
  components: {
    Footer,
    Banner
  },
  setup() {
    let adSoftwareList = ref([]);
    const subpackageOptions = ref([]);
    const page = reactive({
      current: 1,
      total: 0
    });
    const columns = [{
      colKey: 'title',
      title: '广告计划',
      with: '150px',
      ellipsis: true
    }, {
      colKey: 'packageName',
      title: '软件名称',
      with: '150px',
      ellipsis: true
    }, {
      colKey: 'start_time',
      title: '开始时间'
    }, {
      colKey: 'end_time',
      title: '结束时间'
    }, {
      colKey: 'plan_state',
      title: '当前状态'
    }, {
      colKey: 'operator',
      title: '操作'
    }];
    const canAddNewPlane = computed(() => {
      return subpackageOptions.value.length > 0;
    });
    const getAdSoftList = async () => {
      getAdPlanList({
        page: page.current,
        pageSize: 5
      }).then(res => {
        const {
          result,
          total,
          data
        } = res;
        if (result) {
          adSoftwareList.value = data;
          page.total = total;
        }
      });
    };
    const getSubpackageList = async () => {
      const {
        result,
        data
      } = await getUserSoftware();
      if (result) {
        subpackageOptions.value = data;
      }
    };
    const checkEvent = (id, status) => {
      let edit = status == 1 ? 0 : 2;
      // 如果商包为0个，则表示只能查看
      if (!canAddNewPlane.value) {
        edit = 2;
      }
      router.push({
        path: `/editadsoftware`,
        query: {
          id,
          edit
        }
      });
    };
    const editEvent = id => {
      let edit = 1;
      // 如果商包为0个，则表示只能查看
      if (!canAddNewPlane.value) {
        edit = 2;
      }
      router.push({
        path: '/editadsoftware',
        query: {
          id,
          edit
        }
      });
    };
    onMounted(async () => {
      getSubpackageList();
      getAdSoftList();
    });
    const addAdPlane = () => {
      router.push({
        path: '/editadsoftware'
      });
    };
    const goToSoftware = () => {
      router.push('/softwarelibrary');
    };
    watch(() => page.current, val => {
      getAdSoftList();
    });
    return {
      checkEvent,
      editEvent,
      canAddNewPlane,
      moment,
      page,
      columns,
      goToSoftware,
      adSoftwareList,
      personbg: require('../../assets/imgs/personbg.png'),
      addAdPlane,
      router
    };
  }
});